import { UNSET_NOTIFICATION } from '../constants';

export function unsetNotification() {
    return (dispatch) => {
        dispatch({ type: UNSET_NOTIFICATION });
    };
}
